import { isBefore, isValid } from 'date-fns';
import { AccordionSection } from '../../state/infiniteCalendarSeries';
import { longDateFormat } from '../TimedEntrySeries/types';

export const getLocalFormattedDateOrEmpty = (date: string, locale: string) => {
    const parsedDate = new Date(date);
    if (!isValid(parsedDate)) {
        return '';
    }
    return parsedDate.toLocaleDateString(locale, longDateFormat);
};

export const getMonthAndYearFromDate = (utcDate: string) => {
    const date = new Date(utcDate);
    return { month: date.getMonth(), year: date.getFullYear() };
};

export const getCurrentOrFutureMonth = (utcDate: string) => {
    const inputDate = new Date(utcDate);
    const today = new Date();
    const referenceDate = isBefore(inputDate, today) ? today : inputDate;
    return {
        month: referenceDate.getMonth(),
        year: referenceDate.getFullYear(),
    };
};

export const isAccordionSectionOpen = (
    activeSection: AccordionSection | null,
    currentSection: AccordionSection,
): boolean => {
    return activeSection === currentSection;
};
